import React from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from '../Footer';
import Modal from '../Modal';
import { useModal } from '../../contexts/ModalContext';

const Layout = ({ children }) => {
  const { isOpen, modalContent, modalTitle, modalSize, closeModal } = useModal();

  return (
    <div className="flex flex-col h-screen bg-gray-100">
      <Header />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />
        <main className="flex-1 overflow-y-auto">
          <div className="flex flex-col min-h-full">
            <div className="flex-1">
              {children}
            </div>
            <Footer />
          </div>
        </main>
      </div>
      
      {/* Global Modal - available throughout the entire app */}
      <Modal 
        isOpen={isOpen} 
        onClose={closeModal}
        title={modalTitle}
        size={modalSize}
      >
        {modalContent}
      </Modal>
    </div>
  );
};

export default Layout; 